import { HttpClient } from '#client/http/index'
import {
  MemberRequestParams,
  VerifyMemberRequestParams,
  ContractId,
  Contract,
} from '#client/resources/index'

export const memberRequest = async (
  {
    httpClient,
  }: {
    httpClient: HttpClient
  },
  params: MemberRequestParams,
) => {
  return await httpClient.post(
    '/user/serviceForCorporation/requestToBeMember',
    params,
  )
}

export const verifyMemberRequest = async (
  {
    httpClient,
  }: {
    httpClient: HttpClient
  },
  params: VerifyMemberRequestParams,
) => {
  return await httpClient.post(
    '/user/serviceForCorporation/verifyToBeMember',
    params,
  )
}

export const getContract = async (
  {
    httpClient,
  }: {
    httpClient: HttpClient
  },
  contractId: ContractId,
) => {
  const { data } = await httpClient.get<Contract>(
    `/user/serviceForCorporation/contracts/${contractId}`,
  )
  return data
}
